module.exports = __webpack_public_path__ + "static/media/kratos.7e7a297b.mp3";